import React from "react";
import { METHOD_STEPS } from "../data/site";

export default function Method() {
    return (
        <section
            id="metodo"
            data-testid="method-section"
            className="relative py-24 sm:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 bg-grid opacity-30" />
            <div className="absolute top-1/2 -right-32 w-[500px] h-[500px] rounded-full bg-gold/5 blur-3xl" />

            <div className="container mx-auto px-4 sm:px-6 lg:px-10 relative">
                <div className="max-w-3xl">
                    <div className="font-manrope text-sm uppercase tracking-[0.3em] text-gold mb-4">
                        Il Nostro Metodo
                    </div>
                    <h2
                        data-testid="method-title"
                        className="font-oswald font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]"
                    >
                        Quattro fasi.
                        <br />
                        <span className="text-shimmer">Zero approssimazione.</span>
                    </h2>
                    <p className="mt-6 font-manrope text-zinc-400 text-base sm:text-lg max-w-2xl">
                        Ogni cliente segue lo stesso percorso strutturato: dal primo contatto
                        alla revisione settimanale, tutto è pensato per farti progredire.
                    </p>
                </div>

                <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 relative">
                    {/* connecting line */}
                    <div className="hidden lg:block absolute top-8 left-8 right-8 h-[2px] bg-gradient-to-r from-gold/0 via-gold/40 to-gold/0" />

                    {METHOD_STEPS.map((step, i) => (
                        <div
                            key={step.n}
                            data-testid={`method-step-${step.n}`}
                            className="relative group"
                        >
                            <div className="relative z-10 w-16 h-16 rounded-xl bg-ink-surface border-2 border-gold flex items-center justify-center mb-6 group-hover:bg-gold transition-colors duration-300">
                                <span className="font-oswald font-bold text-xl text-gold group-hover:text-ink transition-colors">
                                    {step.n}
                                </span>
                            </div>
                            <h3 className="font-oswald font-bold uppercase text-xl text-white mb-3 tracking-wide">
                                {step.title}
                            </h3>
                            <p className="font-manrope text-zinc-400 text-sm leading-relaxed">
                                {step.text}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
